<template>
    <div data-toggle="tooltip"
         :title="label">
        <b-spinner v-if="queryLoading" style="width: 1.2rem; height: 1.2rem;"></b-spinner>
        <div v-else class="d-flex flex-row align-items-center">
            <template v-if="readOnly">
                <template v-if="!checkResult.isValidated">
                    <overlay-pop v-if="popup"
                                 btn-icon="fa-solid fa-triangle-exclamation icon-cover"
                                 btn-variant="warning">
                        <b-badge variant="light">{{ label }}:{{ checkResult.message }}</b-badge>
                    </overlay-pop>
                    <template v-else>
                        <i class="fa-solid fa-triangle-exclamation color-orange icon-cover"></i>
                        <b-badge variant="light">{{ label }}:{{ checkResult.message }}</b-badge>
                    </template>
                </template>
            </template>
            <i v-else-if="checkResult.isValidated" class="fa-solid fa-check color-green icon-cover"
               aria-hidden="true"></i>
            <template v-else>
                <i class="fa-solid fa-xmark color-red icon-cover"></i>
                <b-badge variant="light" class="cursor-pointer"
                         @dblclick="queryCheck">{{ checkResult.message }}
                </b-badge>
            </template>
        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import OverlayPop from "@/components/workflow/stuffs/OverlayPop.vue";

export default defineComponent({
    name: "ApiCheckValidation",
    components: {OverlayPop},
    props: {
        api: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: '有效性检查'
        },
        readOnly: {
            type: Boolean,
            default: false
        },
        popup: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            queryLoading: true,
            checkResult: {
                isValidated: false,
                message: ''
            }
        }
    },
    watch: {
        api: {
            handler() {
                this.queryCheck();
            },
            immediate: true
        }
    },
    methods: {
        queryCheck() {
            if (this.disable) {
                return;
            }
            this.queryLoading = true;
            this.$store.dispatch('api/get', {
                url: this.api,
            }).then(response => {
                console.log(response);
                let data = response.data;
                if (data !== undefined) {
                    if (typeof data === 'string') {
                        this.checkResult.message = data;
                    } else {
                        this.checkResult = data;
                    }
                } else if (response) {
                    this.checkResult = response;
                }
            }).finally(() => {
                this.queryLoading = false;
                this.$emit('change');
            });
        },
        isValidated() {
            if (this.readOnly) {
                return true;
            }
            if (this.queryLoading) {
                return false;
            }
            return this.checkResult.isValidated;
        },
    }
})
</script>

<style scoped>
.color-green {
    color: #28a745;
}

.color-red {
    color: #d00000;
}

.color-orange {
    color: #ffa500;
}

.icon-cover {
    font-size: 1.2rem;
}
</style>